import React, {useState} from "react";

export function ExpandElipse(props) {
  const [expand, setExpand] = useState(false);

  const start = props.text.substr(0,props.max-1);
  let end = null;
  if (props.text.length > props.max -1) {
    end = props.text.substr(props.max-1, props.text.length + 1);
  }
  return (
    <>
      {start}
      { !expand && end &&
        <>
          ...
          <a
            href={''}
            onClick={
              (e) => {
                e.preventDefault();
                setExpand(true);
              }
            }
          > read more</a>
        </>
      }
      { expand &&
        <>
          {end}
          <a
            href={''}
            onClick={
              (e) => {
                e.preventDefault();
                setExpand(false);
              }
            }
          > read less</a>
        </>
      }
    </>
  )
}

function truncateEllipses(text, max) {
  return text.substr(0,max-1)+(text.length>max?'...':'');
}

export default truncateEllipses
